/**
 * {@docCategory MessageBar}
 */
export var MessageBarType;
(function (MessageBarType) {
  /** Info styled MessageBar */
  MessageBarType[MessageBarType["info"] = 0] = "info";
  /** Error styled MessageBar */
  MessageBarType[MessageBarType["error"] = 1] = "error";
  /** Blocked styled MessageBar */
  MessageBarType[MessageBarType["blocked"] = 2] = "blocked";
  /** SevereWarning styled MessageBar */
  MessageBarType[MessageBarType["severeWarning"] = 3] = "severeWarning";
  /** Success styled MessageBar */
  MessageBarType[MessageBarType["success"] = 4] = "success";
  /** Warning styled MessageBar */
  MessageBarType[MessageBarType["warning"] = 5] = "warning";
})(MessageBarType || (MessageBarType = {}));